export default {"src":"/_next/static/media/TOAST_SUCCESS.313f5752.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};